import React, { useState } from 'react'
import { Box, Button, CircularProgress, Grid2 } from '@mui/material'
import { PrinterIcon } from 'asterX-UI/Icons/PrinterIcon'
import { UserXIcon } from 'asterX-UI/Icons/UserXIcon'
import { PluseIcon } from 'asterX-UI/Icons/PlusIcon'
import { FilePlusIcon2 } from 'asterX-UI/Icons/FilePlusIcon2'
import { ArrowCircleBrokenRight } from 'asterX-UI/Icons/ArrowCircleBrokenRight'
import { ShareIcon } from 'asterX-UI/Icons/ShareIcon'
import { useNavigate } from 'react-router'
import { CalendarCheck } from 'asterX-UI/Icons/CalendarCheck'
import { useAuthStore } from 'context/AuthStore'
import { ACCOUNTANT, HEAD_UNDERWRITER, MANAGER, SUPER_UNDERWRITER, UNDERWRITER } from 'lib/constants/roles'
import { CarIcon } from 'asterX-UI/Icons/CarIcon'
import { AvTimer, Check, ErrorOutline } from '@mui/icons-material'
import { SwitchHorizontal } from 'asterX-UI/Icons/SwitchHorizontal'
import { SlashCircle } from 'asterX-UI/Icons/SlashCircle'
import { CheckCircle } from 'asterX-UI/Icons/CheckCircle'
import { FlipBackward } from 'asterX-UI/Icons/FlipBackward'
import { FileIcon2 } from 'asterX-UI/Icons/FileIcon2'
import { useContractStore } from 'context/ContractStore'
import { SlashCircleIcon } from 'asterX-UI/Icons/SlashCircleIcon'
import UnderwriterModal from 'components/RoleModals/UnderwriterModal/UnderwriterModal'
import ManagerModal from 'components/RoleModals/ManagerModal/ManagerModal'
import AccountantModal from 'components/RoleModals/AccountantModal/AccountantModal'
import PrintModal from 'components/RoleModals/PrintModal/PrintModal'
import EditDocs from '../../asterX-UI/Icons/EditDocs'

const ButtonGroupsByStep = ({ page = 'application' }) => {
  const { authStore } = useAuthStore()
  const navigate = useNavigate()
  const {
    contractStore: { stepCode, loanApplicationData },
    contractStoreFunc: { setManagerWorking }
  } = useContractStore()
  const [currentModal, setCurrentModal] = useState(null)
  const [openPrintModal, setOpenPrintModal] = useState(false)

  let showResign = null

  const openModal = modalName => {
    setCurrentModal(modalName)
    if (authStore.isUserRole === MANAGER) {
      setManagerWorking(true)
    }
  }

  const closeModal = () => {
    setCurrentModal(null)
    if (authStore.isUserRole === MANAGER) {
      setManagerWorking(false)
    }
  }

  const openPrintForms = () => {
    setOpenPrintModal(true)
    if (authStore.isUserRole === MANAGER) {
      setManagerWorking(true)
    }
  }

  const closePrintForms = () => {
    setOpenPrintModal(false)
    if (authStore.isUserRole === MANAGER) {
      setManagerWorking(false)
    }
  }

  /*const isClientDocs = loanApplicationData?.files?.filter(file => file?.category?.step === 'userUploadBankDocs')

  const isAllClientDocsValid = fileCategories
    .filter(doc => doc?.step === 'userUploadBankDocs')
    .every(doc => {
      const fileCount = isClientDocs.filter(file => file?.category?.code === doc?.code)?.length

      return fileCount > 0
    })*/

  // const isDocsCountValid =
  //   (loanApplicationData?.files?.filter(file => file?.category?.step === 'userUploadBankDocs')?.length || 0) < 2
  // const isDealerWithIntegration = 'aster'.includes(loanApplicationData.dealerName)
  // const isDocsCountValid = (
  //   (loanApplicationData?.files?.filter(file => file?.category?.step === 'userUploadBankDocs')?.length || 0) < 2
  // )
  // const isDealerWithIntegration = (
  //   ('aster').includes(loanApplicationData.dealerName)
  // )
  // const isAdminUser = authStore.user.data.username === 'credManager2'

  const renderButtons = () => {
    showResign =
      authStore.isUserRole === MANAGER &&
      page === 'contract' &&
      loanApplicationData?.canResign === true &&
      stepCode !== 'serviceComplete'

    switch (stepCode) {
      case 'userAlternative':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              /* <Button variant="grayText" onClick={openPrintForms}>
                <PrinterIcon />
                Печатные формы
              </Button> */
              <Grid2 display="flex" gap={2} sx={{ marginLeft: 'auto' }}>
                <Button variant="grayText" onClick={() => openModal('ADD_COLLETERAL')}>
                  <PluseIcon />
                  Добавить обеспечение
                </Button>
                <Button variant="grayText" onClick={() => openModal('CHOOSE_ALTERNATIVE')}>
                  <SwitchHorizontal />
                  Выбрать альтернативу
                </Button>
              </Grid2>
            )}
          </>
        )
      case 'serviceRefuse':
        return (
          <>
            {/* <Button variant="grayText" onClick={openPrintForms}>
              <PrinterIcon />
              Печатные формы
            </Button> */}
            <Button
              variant="outlined"
              color="secondary"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontSize: 14,
                padding: '8px 14px',
                marginLeft: 'auto'
              }}
            >
              <SlashCircleIcon />
              Заявке отказано
            </Button>
          </>
        )
      case 'serviceInvalid':
        return (
          <>
            {/* <Button variant="grayText" onClick={openPrintForms}>
              <PrinterIcon />
              Печатные формы
            </Button> */}
            <Button
              variant="outlined"
              color="secondary"
              sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 1,
                fontSize: 14,
                padding: '8px 14px',
                marginLeft: 'auto'
              }}
            >
              <SlashCircleIcon />
              Ошибка в заявке
            </Button>
          </>
        )
      case 'userRevert':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <Button
                variant="contained"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  fontSize: 14,
                  padding: '8px 14px',
                  marginLeft: 'auto'
                }}
                onClick={() => openModal('SUBMIT_FOR_REVIEW')}
              >
                <ArrowCircleBrokenRight />
                Отправить на проверку
              </Button>
            )}
          </>
        )
      case 'userClientConsidering':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <Button
                variant="contained"
                color="success"
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  fontSize: 14,
                  padding: '8px 14px',
                  marginLeft: 'auto'
                }}
                onClick={() => openModal('CLIENT_DECIDED')}
              >
                <CheckCircle />
                Клиент принял решение
              </Button>
            )}
          </>
        )
      case 'serviceWingsData':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <>
                {/* <Button variant="grayText" onClick={openPrintForms}>
                  <PrinterIcon />
                  Печатные формы
                </Button> */}
                <Button
                  variant="outlined"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontSize: 14,
                    padding: '8px 14px',
                    marginLeft: 'auto'
                  }}
                >
                  <CircularProgress size={20} color="info" />
                  Рассмотрение заявки
                </Button>
              </>
            )}
            {[UNDERWRITER, HEAD_UNDERWRITER].includes(authStore.isUserRole) && (
              <>
                <Button
                  variant="outlined"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontSize: 14,
                    padding: '8px 14px',
                    marginLeft: 'auto'
                  }}
                >
                  <CircularProgress size={20} color="info" />
                  Рассмотрение заявки
                </Button>
              </>
            )}
          </>
        )
      case 'userUnderwriterDecision':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <>
                {/* <Button variant="grayText" onClick={openPrintForms}>
                  <PrinterIcon />
                  Печатные формы
                </Button> */}
                <Button
                  variant="outlined"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontSize: 14,
                    padding: '8px 14px',
                    marginLeft: 'auto'
                  }}
                >
                  <CircularProgress size={20} color="info" />
                  Рассмотрение заявки
                </Button>
              </>
            )}

            {[UNDERWRITER, HEAD_UNDERWRITER].includes(authStore.isUserRole) &&
              !loanApplicationData?.activity?.clientRefuse && (
                <>
                  <Grid2 display="flex" gap={2}>
                    <Button variant="grayText">
                      <CarIcon />
                      Отчет об авто
                    </Button>
                  </Grid2>

                  <Grid2 display="flex" gap={2}>
                    <Button variant="grayText" onClick={() => openModal('REVERT')}>
                      <ErrorOutline />
                      Отправить на доработку
                    </Button>

                    <Button variant="grayText" onClick={() => openModal('ALTERNATIVE')}>
                      <SwitchHorizontal />
                      Альтернатива
                    </Button>

                    <Button
                      variant="contained"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('SEND_TO_PROMOTE')}
                    >
                      <ArrowCircleBrokenRight />
                      {authStore.isUserRole === HEAD_UNDERWRITER
                        ? 'Отправить суп. андеррайтеру'
                        : 'Отправить рук. андеррайтеру'}
                    </Button>

                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('REFUSE')}
                    >
                      <SlashCircle />
                      Отказать
                    </Button>

                    <Button
                      variant="contained"
                      color="success"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('APPROVE')}
                    >
                      <CheckCircle />
                      Одобрить заявку
                    </Button>
                  </Grid2>
                </>
              )}

            {[SUPER_UNDERWRITER].includes(authStore.isUserRole) && (
              <>
                <Grid2 display="flex" gap={2} sx={{ marginLeft: 'auto' }}>
                  <Button
                    variant="contained"
                    color="secondary"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                    onClick={() => openModal('REFUSE')}
                  >
                    <SlashCircle />
                    Отказать
                  </Button>
                  <Button
                    variant="contained"
                    color="success"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                    onClick={() => openModal('APPROVE')}
                  >
                    <CheckCircle />
                    Одобрить заявку
                  </Button>
                </Grid2>
              </>
            )}
          </>
        )
      case 'userClientAgreement':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <>
                {!loanApplicationData?.activity?.clientRefuse ? (
                  <Grid2 display="flex" flexWrap="wrap" gap={2} sx={{ marginLeft: 'auto' }}>
                    <Button variant="grayText" onClick={() => openModal('CLIENT_REFUSE')}>
                      <UserXIcon />
                      Отказ клиента
                    </Button>
                    <Button
                      variant="grayText"
                      onClick={() => openModal('CLIENT_CONSENT')}
                      // disabled={isDealerWithIntegration}
                    >
                      <Check />
                      Согласие клиента
                    </Button>
                  </Grid2>
                ) : (
                  <Button
                    variant="outlined"
                    color="secondary"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      fontSize: 14,
                      padding: '8px 14px',
                      marginLeft: 'auto'
                    }}
                  >
                    <SlashCircleIcon />
                    Клиент отказался
                  </Button>
                )}
              </>
            )}
          </>
        )
      case 'userUploadCollateralDocs':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <>
                <Grid2 display="flex" flexWrap="wrap" gap={2}>
                  <Button variant="grayText" onClick={() => openModal('ADD_COLLETERAL')}>
                    <PluseIcon />
                    Добавить обеспечение
                  </Button>
                </Grid2>
                <Grid2 display="flex" flexWrap="wrap" gap={2} justifyContent="flex-end">
                  <Button variant="grayText" onClick={() => openModal('GARANTEE_FILE')}>
                    <PrinterIcon />
                    Гарантийное письмо
                  </Button>
                  <Button variant="grayText" onClick={() => openModal('CLIENT_CONSIDERING')}>
                    <AvTimer />
                    Ожидание клиента
                  </Button>
                  <Button variant="grayText" onClick={() => openModal('UPLOAD_DOCUMENTS')} disabled={false}>
                    {/*disabled={isAdminUser ? false : isDealerWithIntegration}>*/}
                    <FilePlusIcon2 />
                    Загрузить документы
                  </Button>
                  <Button
                    variant="contained"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                    onClick={() => openModal('SUBMIT_FOR_REVIEW')}
                    disabled={false}
                    // disabled={isAdminUser ? false : isDealerWithIntegration}
                  >
                    <ArrowCircleBrokenRight />
                    Отправить на проверку
                  </Button>
                </Grid2>
              </>
            )}
          </>
        )

      case 'userCheckCollateral':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <>
                {/* <Button variant="grayText" onClick={openPrintForms}>
                  <PrinterIcon />
                  Печатные формы
                </Button> */}
                <Button
                  variant="outlined"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontSize: 14,
                    padding: '8px 14px',
                    marginLeft: 'auto'
                  }}
                >
                  <CircularProgress size={20} color="info" />
                  Проверка документов
                </Button>
              </>
            )}
            {[UNDERWRITER, HEAD_UNDERWRITER].includes(authStore.isUserRole) && (
              <Grid2 display="flex" gap={2} marginLeft={'auto'}>
                <Button variant="grayText" onClick={() => openModal('SEND_FOR_REVISION_COLLATERAL_DOCS')}>
                  <FlipBackward />
                  Отправить на доработку
                </Button>

                <Button
                  variant="contained"
                  color="success"
                  sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                  onClick={() => openModal('CREATE_CONTRACT')}
                >
                  <CheckCircle />
                  Создать контракт
                </Button>
              </Grid2>
            )}
          </>
        )
      case 'userUploadBankDocs':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <>
                {!loanApplicationData?.activity?.clientRefuse ? (
                  <>
                    {page === 'application' && (
                      <>
                        <Box display={'flex'} gap={2}>
                          <Button variant="grayText" onClick={openPrintForms}>
                            <PrinterIcon />
                            Печатные формы
                          </Button>
                        </Box>
                        <Button
                          variant="outlined"
                          sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1,
                            fontSize: 14,
                            padding: '8px 14px',
                            order: '3'
                          }}
                          onClick={() => navigate(`/contract/${loanApplicationData?.id}`)}
                        >
                          Перейти к контракту
                          <ShareIcon />
                        </Button>
                      </>
                    )}

                    {page === 'contract' && (
                      <Grid2 width="100%" display="flex" justifyContent="space-between" flexWrap="wrap" gap={2}>
                        <Grid2 display="flex" gap={2}>
                          <Button variant="grayText" onClick={openPrintForms}>
                            <PrinterIcon />
                            Печатные формы
                          </Button>
                          {/*<Button variant="grayText" onClick={() => openModal('CLIENT_REFUSE')}>*/}
                          {/*  <UserXIcon />*/}
                          {/*  Отказ клиента*/}
                          {/*</Button>*/}
                          {/*<Button variant="grayText" onClick={() => openModal('ADD_DETAILS')}>*/}
                          {/*  <FilePlusIcon2 />*/}
                          {/*  Добавить реквизиты*/}
                          {/*</Button>*/}
                        </Grid2>

                        <Grid2 display="flex" gap={2}>
                          <Button
                            variant="grayText"
                            onClick={() => openModal('UPLOAD_DOCUMENTS')}
                            disabled={false}
                            // disabled={isDocsCountValid && isDealerWithIntegration}
                          >
                            {/*disabled={isAdminUser ? false : isDealerWithIntegration}>*/}
                            <FilePlusIcon2 />
                            Загрузить документы
                          </Button>
                          <Button variant="grayText" onClick={() => openModal('CHANGE_ISSUE_DATE_MANAGER')}>
                            <CalendarCheck />
                            Изменить дату выдачи
                          </Button>
                          {/*<Button*/}
                          {/*  variant="contained"*/}
                          {/*  sx={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 1,
                          fontSize: 14,
                          padding: '8px 14px' }}*/}
                          {/*  onClick={() => openModal('SUBMIT_FOR_SIGN_BY_DEALER')}*/}
                          {/*  disabled={false}*/}
                          {/*>*/}
                          {/*  <ArrowCircleBrokenRight />*/}
                          {/*  Отправить на подписание дилеру*/}
                          {/*</Button>*/}
                          <Button
                            variant="contained"
                            color="success"
                            sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                            onClick={() => openModal('SUBMIT_FOR_REVIEW')}
                            disabled={false}
                            // disabled={isAdminUser ? false : isDealerWithIntegration}
                          >
                            <ArrowCircleBrokenRight />
                            Отправить на проверку
                          </Button>
                        </Grid2>
                      </Grid2>
                    )}
                  </>
                ) : (
                  <Button
                    variant="outlined"
                    color="secondary"
                    sx={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 1,
                      fontSize: 14,
                      padding: '8px 14px',
                      marginLeft: 'auto'
                    }}
                  >
                    <SlashCircleIcon />
                    Клиент отказался
                  </Button>
                )}
              </>
            )}
          </>
        )
      case 'userCheckBankDocs':
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <>
                {page === 'application' && (
                  <>
                    {/* <Button variant="grayText" onClick={openPrintForms}>
                      <PrinterIcon />

                    </Button> */}
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: 14,
                        padding: '8px 14px',
                        marginLeft: 'auto'
                      }}
                      onClick={() => navigate(`/contract/${loanApplicationData?.id}`)}
                    >
                      Перейти к контракту
                      <ShareIcon />
                    </Button>
                  </>
                )}

                {page === 'contract' && (
                  <>
                    {/* <Button variant="grayText" onClick={openPrintForms}>
                      <PrinterIcon />
                      Печатные формы
                    </Button> */}
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: 14,
                        padding: '8px 14px',
                        marginLeft: 'auto'
                      }}
                    >
                      <CircularProgress size={20} color="info" />
                      Рассмотрение контракта
                    </Button>
                  </>
                )}
              </>
            )}
            {[UNDERWRITER, HEAD_UNDERWRITER].includes(authStore.isUserRole) && (
              <>
                {page === 'application' && (
                  <>
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: 14,
                        padding: '8px 14px',
                        marginLeft: 'auto'
                      }}
                      onClick={() => navigate(`/contract/${loanApplicationData?.id}`)}
                    >
                      Перейти к контракту
                      <ShareIcon />
                    </Button>
                  </>
                )}

                {page === 'contract' && loanApplicationData?.files && (
                  <Grid2 display="flex" gap={2} marginLeft={'auto'}>
                    <Button variant="grayText" onClick={() => openModal('SEND_FOR_REVISION_BANK_DOCS')}>
                      <FlipBackward />
                      Отправить на доработку
                    </Button>

                    <Button
                      color="success"
                      variant="contained"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      disabled={customFiles.some(item => !item.isRead)}
                      onClick={() => openModal('SEND_TO_FINAL_CHECK')}
                    >
                      <ArrowCircleBrokenRight />
                      Провести выдачу
                    </Button>
                  </Grid2>
                )}
              </>
            )}
          </>
        )
      case 'userHeadUnderwriterDecision':
        return (
          <>
            {[UNDERWRITER, MANAGER].includes(authStore.isUserRole) && (
              <>
                {page === 'application' && (
                  <>
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: 14,
                        padding: '8px 14px',
                        marginLeft: 'auto'
                      }}
                      onClick={() => navigate(`/contract/${loanApplicationData?.id}`)}
                    >
                      Перейти к контракту
                      <ShareIcon />
                    </Button>
                  </>
                )}

                {page === 'contract' && (
                  <>
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: 14,
                        padding: '8px 14px',
                        marginLeft: 'auto'
                      }}
                    >
                      <CircularProgress size={20} color="info" />
                      Финальная проверка
                    </Button>
                  </>
                )}
              </>
            )}
            {[HEAD_UNDERWRITER].includes(authStore.isUserRole) && (
              <>
                {page === 'application' && (
                  <>
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: 14,
                        padding: '8px 14px',
                        marginLeft: 'auto'
                      }}
                      onClick={() => navigate(`/contract/${loanApplicationData?.id}`)}
                    >
                      Перейти к контракту
                      <ShareIcon />
                    </Button>
                  </>
                )}

                {page === 'contract' && (
                  <Grid2 display="flex" gap={2} marginLeft={'auto'}>
                    <Button variant="grayText" onClick={() => openModal('REVERT_ON_FINANCING')}>
                      <FlipBackward />
                      Отправить на доработку
                    </Button>
                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('REFUSE_ON_FINANCING')}
                    >
                      <SlashCircle />
                      Отказать
                    </Button>
                    <Button
                      variant="contained"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('SEND_TO_PROMOTE')}
                    >
                      <ArrowCircleBrokenRight />
                      Отправить суп. андеррайтеру
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('APPROVE_ON_FINANCING')}
                    >
                      <CheckCircle />
                      Согласовать финансирование
                    </Button>
                  </Grid2>
                )}
              </>
            )}
            {[SUPER_UNDERWRITER].includes(authStore.isUserRole) && (
              <>
                {page === 'application' && (
                  <>
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: 14,
                        padding: '8px 14px',
                        marginLeft: 'auto'
                      }}
                      onClick={() => navigate(`/contract/${loanApplicationData?.id}`)}
                    >
                      Перейти к контракту
                      <ShareIcon />
                    </Button>
                  </>
                )}

                {page === 'contract' && (
                  <Grid2 display="flex" gap={2} marginLeft={'auto'}>
                    <Button
                      variant="contained"
                      color="secondary"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('REFUSE_ON_FINANCING')}
                    >
                      <SlashCircle />
                      Отказать
                    </Button>
                    <Button
                      variant="contained"
                      color="success"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('APPROVE_ON_FINANCING')}
                    >
                      <CheckCircle />
                      Согласовать финансирование
                    </Button>
                  </Grid2>
                )}
              </>
            )}
          </>
        )
      case 'userSetDDS':
        const hasExpenseDDS = Array.isArray(loanApplicationData?.dds)
          ? loanApplicationData.dds.some(
              dds => (dds.refunded === false || dds.refunded === null) && dds.type === 'expense'
            )
          : false
        return (
          <>
            {authStore.isUserRole === MANAGER && (
              <>
                {page === 'application' && (
                  <>
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: 14,
                        padding: '8px 14px',
                        marginLeft: 'auto'
                      }}
                      onClick={() => navigate(`/contract/${loanApplicationData?.id}`)}
                    >
                      Перейти к контракту
                      <ShareIcon />
                    </Button>
                  </>
                )}

                {page === 'contract' && (
                  <>
                    <Button
                      variant="outlined"
                      sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                        fontSize: 14,
                        padding: '8px 14px',
                        marginLeft: 'auto'
                      }}
                    >
                      <CircularProgress size={20} color="info" />В процессе финансирования
                    </Button>
                  </>
                )}
              </>
            )}
            {authStore.isUserRole === ACCOUNTANT && (
              <Grid2 display="flex" gap={2} marginLeft="auto">
                <Button variant="grayText" onClick={() => openModal('SEND_FOR_REVISION_ACCOUNTANT')}>
                  <FlipBackward />
                  Отправить на доработку
                </Button>
                {hasExpenseDDS ? (
                  <>
                    <Button
                      variant="contained"
                      color="success"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('UPLOAD_PAYMENT_ORDER')}
                    >
                      <FileIcon2 />
                      Загрузить ПП
                    </Button>
                    <Button
                      variant="contained"
                      color="info"
                      sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                      onClick={() => openModal('UPDATE_DDS')}
                    >
                      <FileIcon2 />
                      Обновить ДДС на расход
                    </Button>
                  </>
                ) : (
                  <Button
                    variant="contained"
                    color="info"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                    onClick={() => openModal('CREATE_DDS')}
                  >
                    <FileIcon2 />
                    Создать ДДС
                  </Button>
                )}
              </Grid2>
            )}
          </>
        )
      case 'serviceComplete':
        return (
          <>
            {authStore.isUserRole === ACCOUNTANT && !loanApplicationData.activity?.clientRefuse && (
              <>
                <Grid2 display="flex" gap={2} marginLeft={'auto'}>
                  <Button
                    variant="contained"
                    color="info"
                    sx={{ display: 'flex', alignItems: 'center', gap: 1, fontSize: 14, padding: '8px 14px' }}
                    onClick={() => openModal('CREATE_DDS_BRAINY_SOFT')}
                  >
                    <FileIcon2 />
                    Создать ДДС на приход
                  </Button>
                </Grid2>
                <Button
                  variant="contained"
                  color="success"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 1,
                    fontSize: 14,
                    padding: '8px 14px',
                    marginLeft: 'auto'
                  }}
                >
                  <CheckCircle />
                  Кредит выдан
                </Button>
              </>
            )}
            {authStore.isUserRole === MANAGER && (
              <Grid2 display="flex" gap={2} marginLeft={'auto'}>
                <Button variant="grayText" onClick={() => openModal('UPLOAD_ISSUED_DOCS')} disabled={false}>
                  <FilePlusIcon2 />
                  Загрузить документы
                </Button>
              </Grid2>
            )}
          </>
        )
      default:
        return null
    }
  }

  const getBankDocs = (data, role) => {
    if (!data?.files) return []

    let bankDocs = data.files.filter(
      file => ['userUploadBankDocs'].includes(file?.category.step) && file.category.code !== 'PF_ZIP'
    )

    if (role === ACCOUNTANT) {
      bankDocs = data.files
        .filter(file =>
          ['userUploadBankDocs', 'userSetDDS', 'generatedBankClient', 'userUploadCollateralDocs'].includes(
            file?.category.step
          )
        )
        .filter(file =>
          [
            'THIRD_PARTY_TRANSFER_APPLICATION',
            'PP',
            'BANK_CLIENT',
            'ACT_OF_GPS',
            'THIRD_PARTY_TRANSFER_GPS_APPLICATION',
            'PAYMENT_INVOICE_BANK_DOCS',
            'PAYMENT_INVOICE_COLLATERAL_DOCS',
            'ACCESSION_APPLICATION',
            'THIRD_PARTY_TRANSFER_GPS_APPLICATION_QR',
            'DMC_QR',
            'THIRD_PARTY_TRANSFER_APPLICATION_QR',
            'DMC'
          ].includes(file?.category.code)
        )
    }
    if (role === MANAGER) {
      bankDocs = bankDocs.concat(data.files.filter(file => ['PP'].includes(file?.category.code)))
    }

    return bankDocs
  }

  const clientDocs =
    loanApplicationData?.files?.filter(
      file =>
        ['userCreateLoanApplication', 'userRevert'].includes(file?.category?.step) && file?.collateralClientId === null
    ) || []

  const pledgeDocs =
    loanApplicationData?.files?.filter(file => ['userUploadCollateralDocs'].includes(file?.category?.step)) || []

  const bankDocs = getBankDocs(loanApplicationData, authStore?.isUserRole) || []
  const wingsDocs = loanApplicationData?.files?.filter(file => file?.category?.step === 'wings') || []
  const customFiles = [...clientDocs, ...pledgeDocs, ...bankDocs, ...wingsDocs]

  return (
    <>
      <Grid2
        size={{ xs: 12 }}
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: '12px',
          marginBottom: '12px'
        }}
      >
        {renderButtons()}

        {showResign && (
          <Grid2 display="flex" gap={2} width={'320px'} order={-1}>
            <Button
              variant="grayText"
              sx={{ textWrap: 'nowrap', marginRight: '8px' }}
              onClick={() => openModal('RESIGN_DOCUMENTS')}
            >
              <EditDocs />
              Переподписать документы
            </Button>
          </Grid2>
        )}
      </Grid2>

      {currentModal && (
        <>
          {authStore.isUserRole === MANAGER && <ManagerModal currentModal={currentModal} closeModal={closeModal} />}

          {[UNDERWRITER, HEAD_UNDERWRITER, SUPER_UNDERWRITER].includes(authStore.isUserRole) && (
            <UnderwriterModal currentModal={currentModal} closeModal={closeModal} />
          )}

          {authStore.isUserRole === ACCOUNTANT && (
            <AccountantModal currentModal={currentModal} closeModal={closeModal} />
          )}
        </>
      )}

      {openPrintModal && <PrintModal openModal={openPrintModal} closeModal={closePrintForms} />}
    </>
  )
}

export default ButtonGroupsByStep
